import { kaspreadsheetUrl } from '@/mocks/categories';

export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 bg-background-50 text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-5 whitespace-nowrap">
              Why Choose Us
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading text-foreground-950 leading-tight">
              Built for Resellers
              <br />
              Who Mean Business
            </h2>
            <p className="mt-4 text-base text-foreground-500 max-w-lg leading-relaxed">
              GTBuy Spreadsheet is trusted by thousands of resellers across eBay, Poshmark, Amazon, and boutique stores. Our tools help you source smarter, track better, and profit more — without the complexity of enterprise software.
            </p>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-primary-600 rounded-3xl p-8 md:p-10 relative overflow-hidden">
              <div className="absolute top-6 right-6 flex gap-1.5">
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
                <span className="w-2 h-2 rounded-full bg-white/50"></span>
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
              </div>
              <span className="text-xs font-semibold text-white/60 uppercase tracking-wider whitespace-nowrap">
                Trusted Platform
              </span>
              <blockquote className="mt-6 text-lg md:text-xl text-white font-medium leading-relaxed font-heading">
                &ldquo;GTBuy Spreadsheet completely transformed how I manage my sourcing. I went from chaotic spreadsheets to a clean, organized system that saves me at least 10 hours every week.&rdquo;
              </blockquote>
              <div className="mt-8 flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20late%2020s%20with%20wavy%20auburn%20hair%2C%20genuine%20warm%20smile%2C%20wearing%20a%20cream%20silk%20blouse%2C%20light%20oatmeal%20studio%20background%2C%20soft%20natural%20portrait%20lighting%2C%20minimalist%20professional%20photography&width=120&height=120&seq=avatar-sarah-v2&orientation=squarish"
                    alt="Sarah Mitchell"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">Sarah Mitchell</p>
                  <p className="text-xs text-white/60">Full-Time eBay Reseller, 3+ Years</p>
                </div>
                <a
                  href={kaspreadsheetUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="ml-auto inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/15 hover:bg-white/25 text-white text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Try It Now
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}